import { EnvironmentCountries, MultilingualCodeSystems } from '@e-origin/shared';

import { CustomsFlow, Variant } from '../types';
import { beExport } from './be.export';
import { beImport } from './be.import';
import { forwarderExport } from './forwarder.export';
import { forwarderImport } from './forwarder.import';
import { frExport } from './fr.export';
import { frImport } from './fr.import';
import { nlExport } from './nl.export';
import { nlImport } from './nl.import';

export const VARIANTS = {
  [EnvironmentCountries.BE]: { IMPORT: beImport, EXPORT: beExport },
  [EnvironmentCountries.NL]: { IMPORT: nlImport, EXPORT: nlExport },
  [EnvironmentCountries.FR]: { IMPORT: frImport, EXPORT: frExport },
} satisfies Record<EnvironmentCountries, Record<CustomsFlow, Variant>>;

export const FORWARDER_VARIANTS = {
  IMPORT: forwarderImport,
  EXPORT: forwarderExport,
} satisfies Record<CustomsFlow, Variant>;

export const CODELIST_SYSTEMS = {
  [EnvironmentCountries.BE]: {
    IMPORT: [MultilingualCodeSystems.CCI, MultilingualCodeSystems.IDMS],
    EXPORT: [MultilingualCodeSystems.AES, MultilingualCodeSystems.AESBE],
  },
  [EnvironmentCountries.NL]: {
    IMPORT: [MultilingualCodeSystems.CCI, MultilingualCodeSystems.DMS],
    EXPORT: [MultilingualCodeSystems.AES, MultilingualCodeSystems.AESNL],
  },
  // temporary added the IDMS and AESBE for FR, as the code list system is not yet implemented for FR.
  [EnvironmentCountries.FR]: {
    IMPORT: [MultilingualCodeSystems.CCI, MultilingualCodeSystems.IDMS],
    EXPORT: [MultilingualCodeSystems.AES, MultilingualCodeSystems.AESBE],
  },
} satisfies Record<EnvironmentCountries, Record<CustomsFlow, MultilingualCodeSystems[]>>;
